import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-academics-create',
  templateUrl: './academics-create.component.html',
  styleUrls: ['./academics-create.component.scss']
})
export class AcademicsCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/academicsbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              imagealt: data.data.imagealt,
              imagetitle: data.data.imagetitle,
              imagedesc: data.data.imagedesc,
              type: data.data.type,
              subtitle: data.data.subtitle,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.Form = this.formBuilder.group({
      imagealt: [''],
      imagetitle: ['', Validators.required],
      imagedesc: [''],
      type: ['', Validators.required],
      subtitle: [''],
      seohidden: [''],
      _id: ['']
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "imagealt" : this.Form.value.imagealt,
      "imagetitle" : this.Form.value.imagetitle,
      "imagedesc" : this.Form.value.imagedesc,
      "type" : this.Form.value.type,
      "subtitle" : this.Form.value.subtitle,
      "seohidden": this.Form.value.seohidden,
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/academics', data).subscribe(
      res => {
        // console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/academics/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
  }else{
    var data1 = {
      "imagealt" : this.Form.value.imagealt,
      "imagetitle" : this.Form.value.imagetitle,
      "imagedesc" : this.Form.value.imagedesc,
      "type" : this.Form.value.type,
      "subtitle" : this.Form.value.subtitle,
      "_id" : this.Form.value._id,
      "seohidden" : this.Form.value.seohidden
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/academics/', data1).subscribe(
      res => {
        // console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/academics/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
